import { Box, Grid2 as Grid, Typography } from '@mui/material';

import MobileContentBG from '../../assets/mobileContentBG.png';
import PlatformImg from '../../assets/welcome-chars.png';
import React from 'react';
import content_Bg from '../../assets/ContentBG.webp';

interface PlatformProps {
  isMobile?: Boolean | null;
}

const Platform: React.FC<PlatformProps> = ({ isMobile }) => {
  const renderImage = () => (
    <Grid size={{ xs: 12, md: 4 }}>
      <Box display="flex" justifyContent="center" alignItems="center" sx={{ marginLeft: { xs: 0, md: 20 } }}>
        <img
          src={PlatformImg}
          alt="learning"
          style={{
            width: isMobile ? '270px' : 460,
            height: isMobile ? '270px' : 460
          }}
        />
      </Box>
    </Grid>
  );

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden'
      }}>
      <Grid container justifyContent="center" alignItems="center">
        {!isMobile && renderImage()}
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          size={{ xs: 12, md: 8 }}
          sx={{ display: { xs: 'none', md: 'flex' } }}>
          <Box p={6}>
            <Typography
              style={{
                fontFamily: 'Bevan',
                fontSize: '48px',
                lineHeight: '1'
              }}>
              <span style={{ color: 'white' }}>{`“ `}</span>
              <span
                style={{
                  background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}>
                {` World's`}
              </span>
            </Typography>
            <Typography
              style={{
                fontFamily: 'Bevan',
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: '48px'
              }}>
              {`Frist Platform for`}
            </Typography>
            <Typography
              style={{
                fontFamily: 'Bevan',
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: '48px'
              }}>
              {`ChildHood`}
            </Typography>
            <Typography
              style={{
                fontFamily: 'Bevan',
                fontSize: '48px'
              }}>
              <span
                style={{
                  background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}>
                {`Productivity! `}
              </span>

              <span style={{ color: 'white' }}>{`”`}</span>
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Baloo2',
                color: '#fff',
                whiteSpace: 'pre-line',
                fontSize: '19px'
              }}>
              Celebrate every child. Reward every effort! Children can do what they love {'\n'}
              —paint, write, sing, sculpt, and more & and get rewarded for their focus
              {'\n'}
              and creativity. Building confidence and self-esteem.
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid container justifyContent="center" alignItems="center">
        <Grid
          size={{ xs: 12, md: 8 }}
          sx={{
            display: { xs: 'block', md: 'none' },
            margin: '30px 0'
          }}>
          <Typography fontSize={20} fontWeight={800} fontFamily={'Bevan'} align="center">
            <span style={{ color: 'white' }}>{`“ `}</span>
            <span
              style={{
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
              {`   World's`}
            </span>
          </Typography>

          <Typography
            fontSize={20}
            fontWeight={800}
            fontFamily={'Bevan'}
            align="center"
            sx={{
              background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
            First Platform for
          </Typography>
          <Typography
            fontSize={20}
            fontWeight={800}
            fontFamily={'Bevan'}
            align="center"
            sx={{
              background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
            Childhood
          </Typography>
          <Typography fontSize={20} fontWeight={800} fontFamily={'Bevan'} align="center">
            <span
              style={{
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
              {` Productivity! `}
            </span>

            <span style={{ color: 'white' }}>{`”`}</span>
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Baloo2',
              fontWeight: 500,
              fontSize: '15px',
              pt: '10px',
              color: 'white',
              textAlign: 'center',
              margin: '0 40px'
            }}>
            Celebrate every child. Reward every effort! Children can do what they love{'\n'}
            —paint, write, sing, sculpt, and more & and get rewarded for their focus{'\n'}
            and creativity. Building confidence and self-esteem.
          </Typography>
        </Grid>
        {isMobile && renderImage()}
      </Grid>
    </Box>
  );
};

export default Platform;
